export default __webpack_public_path__ + "static/media/img_24.08d41090.jpg";